// extracted by mini-css-extract-plugin
export default {"wrapper":"LMtLs","list":"q48Rr"};